export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * Build the Google OAuth 2.0 authorization URL the user is redirected to when
 * they click "Sign in".
 *
 * Encodes the current origin + optional return path into the `state` parameter
 * so the server callback knows where to send the user after authentication.
 */
export const getLoginUrl = (returnPath: string = "/") => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  if (!clientId) {
    // eslint-disable-next-line no-console
    console.error(
      "[Auth] VITE_GOOGLE_CLIENT_ID is not configured. Sign-in will not work.",
    );
  }

  const origin = window.location.origin;
  const redirectUri = `${origin}/api/oauth/callback`;

  // The state must be opaque to Google but parseable by our callback handler.
  // We use base64-encoded JSON (matches server/_core/oauth.ts parseState).
  const state = btoa(JSON.stringify({ origin, returnPath }));

  const url = new URL("https://accounts.google.com/o/oauth2/v2/auth");
  url.searchParams.set("client_id", clientId ?? "");
  url.searchParams.set("redirect_uri", redirectUri);
  url.searchParams.set("response_type", "code");
  url.searchParams.set("scope", "openid email profile");
  url.searchParams.set("state", state);
  url.searchParams.set("access_type", "online");
  url.searchParams.set("prompt", "select_account");

  return url.toString();
};
